module.exports = __webpack_public_path__ + "static/img/MinionsNew.fd3a38ea.jpg";